import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { Stagione } from '../../shared/interface';

@Component({
  selector: 'app-stagione-home',
  templateUrl: './stagione-home.component.html',
  styleUrl: './stagione-home.component.css'
})
export class StagioneHomeComponent implements OnInit {

  constructor(private apiService: ApiService) { }

  stagione?: Stagione;

  ngOnInit(): void {

    this.apiService.getStagione().subscribe({
      next: (data) => this.stagione = data,
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
    })
  }
}
